export default __webpack_public_path__ + "static/media/ChristineJones-5.2347e44b.jpg";